// extracted by mini-css-extract-plugin
module.exports = {"checkout_container":"index-module__checkout_container___9stXB","headline_sec":"index-module__headline_sec___2jAmN","desk_img":"index-module__desk_img___MWS65"};